import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {Popover, PopoverModule} from 'primeng/popover';
import { environment } from 'src/environments/environment';

import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-quick-access-panel',
  templateUrl: './quick-access-panel.component.html',
  styleUrls: ['./quick-access-panel.component.scss'],
  imports: [
    PopoverModule,
    TranslatePipe,
    Popover
]
})
export class QuickAccessPanelComponent {
    @Output() panelToggle = new EventEmitter<boolean>();

    @ViewChild('op') overlayPanel!: Popover;

    items: QuickAccessItem[] = [
        { name: 'menu.quickAccess.exploitation', icon: '/images/quick-access/engie.ico', url: environment.quickAccess.exploitation },
        { name: 'menu.quickAccess.analyse', icon: '/images/quick-access/engie.ico', url: environment.quickAccess.analyse },
        { name: 'menu.quickAccess.synoptique', icon: '/images/quick-access/engie.ico', url: environment.quickAccess.synoptique },
        { name: 'menu.quickAccess.clientArea', icon: '/images/quick-access/client-area.svg', url: environment.quickAccess.clientArea },
        { name: 'menu.quickAccess.daf', icon: '/images/quick-access/daf.png', url: environment.quickAccess.daf },
        { name: 'menu.quickAccess.lng', icon: '/images/quick-access/lng.png', url: environment.quickAccess.lng },
    ];

    toggle(event: Event) {
        this.overlayPanel.toggle(event);
    }
}

interface QuickAccessItem {
    name: string;
    icon: string;
    url: string;
}
